import { useEffect } from "react"

import getDisplayCondition from "../../../service/getDisplayCondition"
import type EstimateValues from "../../../types/params"
import useReceivableDates from "./useReceivableDates"

const useSetInitialMaterialsArrivalDate = (values: EstimateValues, setDate: (date: Date) => void) => {
  const { existsResponse, minDate } = useReceivableDates()
  useEffect(() => {
    const isDisplayed = getDisplayCondition(values)
    if (existsResponse && !isDisplayed.materialsArrivalDate) {
      setDate(minDate)
    }

    // レスポンスが帰ってきた初回のみ実行する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existsResponse])
}

export default useSetInitialMaterialsArrivalDate
